module.exports = __webpack_public_path__ + "images/2a4ce19c1287db4605467fd06cd61aaf.png";